export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    if (file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    } else if (typeof file === "string") {
      // Already a base64 string or data URL
      resolve(file);
    } else {
      reject(new Error("Invalid file type"));
    }
  });
};
